import { render, staticRenderFns } from "./reglamento.vue?vue&type=template&id=565fa7f7&lang=html&"
import script from "./reglamento.vue?vue&type=script&lang=js&"
export * from "./reglamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports